<template>
  <section>
    <div class="dashboard flex justify-center mt-48 md:pb-50">
      <section>
        <div class="flex flex-col items-center text-center">
          <h2 v-if="headingText" class="text-h1 mx-16">{{ headingText }}</h2>
          <p v-if="subheadingText" class="text-small mx-16 my-8 text-grey-text-subdued">{{ subheadingText }}</p>
        </div>
        <div class="my-24 flex justify-center">
          <ul class="inline-grid grid-cols-2 lg:flex lg:flex-wrap lg:justify-center care-type-card m-8">
            <CareTypeCard
              v-for="careType in careTypes"
              :key="careType.key"
              :careType="careType"
              :selected="selectedCareType === careType"
              @click="selectCareType"
            />
          </ul>
        </div>
      </section>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import { CareType } from '../../types/care_type';
import CareTypeCard from './CareTypeCard.vue';

export default Vue.extend({
  name: 'PoppinsCareTypeCardGroup',
  components: {
    CareTypeCard,
  },
  props: {
    headingText: {
      type: String,
      default: '',
    },
    subheadingText: {
      type: String,
      default: '',
    },
    careTypes: {
      default: () => ['BABYSITTER', 'NANNY', 'HOUSEKEEPING', 'PET_CARE', 'COMPANION_CARE'],
      type: Array,
    },
  },
  data(): any {
    return {
      selectedCareType: '',
    };
  },
  methods: {
    selectCareType(careType: CareType) {
      if (careType) {
        this.selectedCareType = careType;
        this.selectAnimation(careType);
        this.$emit('select', careType);
      }
    },
    selectAnimation(careType: CareType) {
      const selectedCard = this.$el.querySelector(`.care-type-card #${careType}`);
      const unselectedCards = this.$el.querySelectorAll(`.care-type-card button:not(#${careType})`);
      selectedCard.classList.add('care-type-card__visible');
      unselectedCards.forEach((el) => el.classList.add('care-type-card__hidden'));
      this.$el.querySelector(`.care-type-card #${careType} div`).classList.add('no-outline');
    },
  },
});
</script>

<style lang="scss" scoped>
.care-type-card {
  &__visible {
    z-index: 10;
  }

  &__hidden {
    opacity: 0;
    width: 0;
    margin: 0;
    padding: 0;
    visibility: hidden;
    -webkit-transition: none;
    transition: none;

    @media only screen and (min-width: 864px) {
      transition-property: opacity, width, margin, padding;
      -webkit-transition: all 0.2s ease-in;
      transition: all 0.2s ease-in;
    }
  }
}
.no-outline {
  outline: none !important;
}
</style>
